export default () => {
    const cursor = document.querySelector('.cursor');
    const footer = document.querySelector('footer');
    if (cursor) {
        document.addEventListener('mousemove', moveCursor);

        footer.addEventListener('mouseenter', () => {
            cursor.classList.add('highlight');
        });

        footer.addEventListener('mouseleave', () => {
            cursor.classList.remove('highlight');
        });

        function moveCursor(e) {
            let x = e.clientX;
            let y = e.clientY;
            cursor.style.left = `${x}px`;
            cursor.style.top = `${y}px`;
        }
    }
};
